<template>
  <div class="[ mk-organisationform ] col-12 px-0 pb-0">
    <div class="">

      <div class="[ dashboard-card admin-input-wrap ] col-12">

        <v-row>
          <v-col cols="12" class="pb-0">
            <h2 style="margin-bottom: 13px;">Details</h2>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <label>Name</label>
            <v-text-field
              outlined
              v-model="organisation.name"
              placeholder=""
              class="text-field"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <label>Business Number (ABN)</label>
            <v-text-field
              outlined
              v-model="organisation.abn"
              placeholder=""
              class="text-field"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <label>Email</label>
            <v-text-field
              outlined
              v-model="organisation.email"
              placeholder=""
              class="text-field"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <label>Website</label>
            <v-text-field
              outlined
              v-model="organisation.website"
              placeholder=""
              class="text-field"
            ></v-text-field>
          </v-col>
        </v-row>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    organisation: {
      type: Object,
    },
  },
  data() {
    return {
        type: this.organisation.id ? 'edit' : 'create'
    };
  },
  methods: {
    async handleSubmit() {
      this.organisation.save().then((response) => {
        if (response.id && this.type == 'create') {
          window.location.href = "/admin/organisations/" + response.id + "/edit";
        }
      });
    },
  },
};
</script>
